import { html, LitElement } from 'lit';
import ShopifyCart from '@/components/ShopifyCart';
import { property } from 'lit/decorators.js';

export default class ShopifyCartToggle extends LitElement {
  static component = 'b-shopify-cart-toggle';

  @property()
  qty = 0;

  cartEl: ShopifyCart | null = null;

  protected createRenderRoot() {
    return this;
  }

  connectedCallback() {
    super.connectedCallback();
    this.cartEl = document.querySelector('b-shopify-cart');
  }

  toggleOpen() {
    this.cartEl?.toggleOpen();
  }

  setQty(qty: number) {
    this.qty = qty;
  }

  render() {
    return this.qty ? html`<div class="cart-toggle text-14 font-medium cursor-pointer hover-text flex gap-2 items-center" @click="${this.toggleOpen}">
      <span class="inline-block w-6 h-6">
        <svg viewBox="0 0 34 34" xmlns="http://www.w3.org/2000/svg">
          <path d="M10.856 33.6387C9.99877 33.6387 9.26682 33.3335 8.66016 32.7233C8.05377 32.1127 7.75057 31.379 7.75057 30.522C7.75057 29.6648 8.05585 28.9328 8.66641 28.3262C9.27668 27.7198 10.0104 27.4166 10.8677 27.4166C11.7249 27.4166 12.4567 27.7219 13.0631 28.3324C13.6695 28.9427 13.9727 29.6765 13.9727 30.5337C13.9727 31.3909 13.6675 32.1227 13.0572 32.7291C12.4467 33.3355 11.7129 33.6387 10.856 33.6387ZM27.5227 33.6387C26.6654 33.6387 25.9335 33.3335 25.3268 32.7233C24.7204 32.1127 24.4172 31.379 24.4172 30.522C24.4172 29.6648 24.7225 28.9328 25.3331 28.3262C25.9433 27.7198 26.6771 27.4166 27.5343 27.4166C28.3915 27.4166 29.1234 27.7219 29.7297 28.3324C30.3361 28.9427 30.6393 29.6765 30.6393 30.5337C30.6393 31.3909 30.3342 32.1227 29.7239 32.7291C29.1133 33.3355 28.3796 33.6387 27.5227 33.6387ZM8.94516 6.41659L13.3339 15.5278H25.2227L30.2227 6.41659H8.94516ZM7.58391 3.63867H32.1414C32.7797 3.63867 33.2654 3.92811 33.5985 4.507C33.9313 5.08561 33.9357 5.66659 33.6118 6.24992L27.8893 16.5553C27.5838 17.0926 27.1828 17.5185 26.6864 17.8333C26.19 18.148 25.6465 18.3053 25.056 18.3053H12.5006L10.3339 22.3053H30.6393V25.0833H10.5839C9.38946 25.0833 8.51446 24.6412 7.95891 23.757C7.40335 22.8726 7.39877 21.9258 7.94516 20.9166L10.4727 16.2778L4.25057 3.11117H0.972656V0.333252H6.02849L7.58391 3.63867Z" />
        </svg>
      </span>
      <span>${this.qty}</span>
    </div>` : '';
  }
}
